import { PageLayout } from "@/components/layout/PageLayout";

const Terms = () => {
  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-foreground mb-4">Termeni și Condiții – OptiRO.ai (MVP)</h1>
        <p className="text-muted-foreground mb-8">Ultima actualizare: Februarie 2026</p>

        <div className="prose prose-slate dark:prose-invert max-w-none space-y-8">
          <p className="text-muted-foreground leading-relaxed">
            Website-ul OptiRO.ai este un produs aflat în versiune MVP (Minimum Viable Product), destinat testării funcționalităților de analiză SEO și Generative Engine Optimization (GEO).
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Prin utilizarea acestui website, accepți termenii și condițiile de mai jos.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Pentru întrebări oficiale: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
          </p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">1. Descrierea serviciului (MVP)</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">În forma actuală, OptiRO.ai oferă:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Analiză automată a unui URL introdus de utilizator</li>
              <li>Generare scor SEO și GEO</li>
              <li>Analiză orientativă privind: percepția AI, autoritatea domeniului, semnale structurale</li>
              <li>Trimiterea unui raport informativ prin email</li>
              <li>Înscrierea opțională în lista de notificare (waitlist)</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">⚠️ Serviciul este gratuit în această fază și are caracter informativ.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">2. Limitarea serviciului</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Versiunea MVP:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>NU implementează modificări pe site-ul tău</li>
              <li>NU are acces la CMS-ul tău</li>
              <li>NU modifică conținutul site-ului tău</li>
              <li>NU oferă consultanță personalizată automată</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Analiza se bazează pe crawling automat, modele algoritmice și sisteme AI. Rezultatele sunt orientative și nu reprezintă o garanție de performanță.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">3. Fără garanții de poziționare</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">OptiRO.ai:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Nu este afiliat cu Google, OpenAI, Gemini, Perplexity sau alte platforme AI</li>
              <li>Nu controlează algoritmii acestora</li>
              <li>Nu garantează: poziția 1 în Google, apariția în răspunsurile ChatGPT, creșteri imediate de trafic</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Orice optimizare ulterioară depinde de implementare și context competitiv.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">4. Utilizarea responsabilă</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Utilizatorul se obligă:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Să introducă doar site-uri publice</li>
              <li>Să nu folosească platforma pentru activități ilegale</li>
              <li>Să nu încerce exploatarea tehnică a sistemului</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Ne rezervăm dreptul de a bloca accesul în caz de abuz.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">5. Date colectate</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">În versiunea MVP, colectăm:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>URL-ul introdus</li>
              <li>Adresa de email</li>
              <li>Informații tehnice minimale pentru funcționarea platformei</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Datele sunt utilizate exclusiv pentru: generarea raportului, notificarea privind lansarea și comunicarea ofertelor viitoare. Nu vindem și nu transferăm date către terți.
            </p>
            <p className="text-muted-foreground leading-relaxed mt-2">
              Pentru solicitări legate de date: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">6. Proprietate intelectuală</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Toate materialele de pe site (texte, scoruri, structură analiză, metodologie, branding) aparțin OptiRO.ai. Este interzisă:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Copierea metodologiei</li>
              <li>Reutilizarea conținutului fără acord scris</li>
              <li>Reproducerea parțială sau totală în scop comercial</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">7. Actualizări viitoare</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              OptiRO.ai este în fază de dezvoltare. Ne rezervăm dreptul de a:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Modifica funcționalitățile</li>
              <li>Introduce planuri plătite</li>
              <li>Actualiza prețurile</li>
              <li>Actualiza termenii și condițiile</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Utilizatorii vor fi informați în mod transparent despre aceste modificări.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">8. Disponibilitatea serviciului</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Platforma MVP poate fi:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Actualizată</li>
              <li>Suspendată temporar</li>
              <li>Modificată fără notificare prealabilă</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Fiind o versiune de test, nu garantăm funcționare continuă 24/7.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">9. Răspundere limitată</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">OptiRO.ai nu este responsabil pentru:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Decizii de business luate pe baza raportului</li>
              <li>Pierderi financiare</li>
              <li>Interpretări eronate ale datelor generate automat</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Raportul are caracter informativ și educațional.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">10. Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              Pentru orice solicitare oficială: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </PageLayout>
  );
};

export default Terms;
